import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import { InputGroup } from "react-bootstrap";
import Icons from "../../../../components/icon";
import { DataTable2 } from "../../../common/table/data-table/data-table-component";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import { FormControl } from "react-bootstrap";
import Icon from "../../../icon";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { MAX_LENGTH as maxLength } from "../../../../../app/constants/external-constants";

class UserDetailsInfo extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.resetDefault=this.resetDefault.bind(this);
    this.state={
      show:false,
      clearData:false,
      searchVal: "",
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[]
    }
  }
  componentDidMount() {
    const { endUserID, inventoryCircuit, getUserHrDetails, getUserCircuitAllocation, getUserLinkedCircuit} = this.props
    getUserHrDetails(endUserID);
    getUserCircuitAllocation(endUserID);
    getUserLinkedCircuit(endUserID);
  }
  handleClose(){
    this.setState({show:false});
  }

  handleShow() {   
    const { endUserID, inventoryCircuit, getUserHrDetails, getUserCircuitAllocation, getUserLinkedCircuit} = this.props
    getUserHrDetails(endUserID);
    getUserCircuitAllocation(endUserID); 
    getUserLinkedCircuit(endUserID);
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };

  resetDefault() {   
    this.setState({clearData:true});
  }

  resetClearData(item) {
    this.setState({clearData:item})
  }

  setSearchValue = (e) => {
    this.setState({ searchVal: e.target.value });
  }

  toLocaleLanguage = (key) => {
    const { locale } = this.props;
    if (locale === null || locale === '' || locale === undefined)
        return translation[translation['defaultLocaleLanguage']][key];

    return translation[locale][key];
  }

    searchAction = async (e) => {
        const { endUserID } = this.props;
        let searchVal = e.target.value;
        this.props.setUserLinkedCircuitSearchValue(searchVal);
        if (e.key === 'Enter') {
            await this.props.getUserLinkedCircuit(endUserID, searchVal);
            e.preventDefault();
        }
        
    }

    navigateToDetails(rowItem) {
        if (rowItem != null) {
            window.open(`/external/inventory/linked-circuit/${rowItem.ID}`, "_blank")
        }
    }
 
  render(){
    const { show } = this.state;
    const { getUserLinkedCircuit, endUserID } = this.props;
    return(
      <>

        <Icon
            name="circle-info-reg"
            size="18px"
            customClassName="icon-nav"            
            containerClass="info-container"
            onClick={this.handleShow.bind(this)}
        />
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-dialog-container none-scroll"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                    <div className="inventory-detail-info-container data-table data-table-dark">
              <div className="detail-info-wrapper">
                 <table className="detail-main-table detail-info-table">
                   <tbody>
                      <tr>
                          <td>{this.toLocaleLanguage('hr_sap_id_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.hrSapId : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('first_name_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.firstName : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('last_name_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.lastName : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('middle_initial_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.middle : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('email_address_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.emailAdd : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('position_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.position : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('status_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.status : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('date_left_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.dateleft : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('first_lm_hr_sap_id_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.firstLineManagerId : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('first_lm_email_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.firstLineManagerEmailAdd : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('second_lm_hr_sap_id_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.secondLineManagerId : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('second_lm_email_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.secondLineManageremailAdd : null}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('delegate_approver_capital')}</td>
                          <td>{this.props.userDetails != null ? this.props.userDetails.delegateAprover : null}</td>
                        </tr>
                   </tbody>
                 </table>
                 <h1>{this.toLocaleLanguage('location_capital')}</h1>
                 <table className="detail-main-table detail-info-table">
                    <tbody>
                      <tr>
                        <td>{this.toLocaleLanguage('location_site_id_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.locationSiteId : null}
                        </td>
                      </tr>
                      <tr>
                        <td>{this.toLocaleLanguage('address_1_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.address1 : null}
                        </td>
                      </tr>
                      <tr>
                        <td>{this.toLocaleLanguage('address_2_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.address2 : null}
                        </td>
                      </tr>
                      <tr>
                        <td>{this.toLocaleLanguage('city_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.city : null}
                        </td>
                      </tr>
                      <tr>
                        <td>{this.toLocaleLanguage('state_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.locationState : null}
                        </td>
                      </tr>
                       <tr>
                        <td>{this.toLocaleLanguage('country_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.country : null}
                        </td>
                      </tr>
                       <tr>
                        <td>{this.toLocaleLanguage('zip_capital')}</td>
                        <td>
                          {this.props.userDetails != null ? this.props.userDetails.locationZip : null}
                        </td>
                      </tr>
                    </tbody>
                 </table>
                 <h1>{this.toLocaleLanguage('cost_allocation_capital')}</h1>
                 <TablePagination 
                        classNameWrapper="table-container"
                        columns={this.props.inventoryCircuit.inventoryUserCircuitAllocation.Headers != undefined ? this.props.inventoryCircuit.inventoryUserCircuitAllocation.Headers : []} 
                        pageList={[]}
                        isDataLoaded={true}
                        paginationHidden={true}
                        showSearchBox={false}
                        isNotSortable={true}
                        //pages={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination}
                        //paginationAction={getUserLinkedCircuit}
                        // searchVal = {this.state.searchVal}
                        // enableUpdate={this.enableEquipmentUpdate.bind(this)}
                        // showDetails={this.ShowEquipmentDetails.bind(this)}
                        // rowClickAction={this.handelToggleDropdown.bind(this, Selected_Index.i_Six)}
                        // haveExternalDeleteBtn={true}
                        // isNotSortable={true}
                        // pageList={this.props.inventoryCircuit.inventoryUserCircuitAllocation.Data != undefined ? this.props.inventoryCircuit.inventoryUserCircuitAllocation.Data : []}    
                  />
                 {/* {this.props.costAllocationData.map((item,id)=>
                    <DataTable2 key={id} id={id} item={item} header={this.props.inventoryCircuit.inventoryUserCircuitAllocation.Headers} showSearchBox={false} data={this.props.inventoryCircuit.inventoryUserCircuitAllocation.Data} isDataLoaded={true} customClassName="table-container" />
                )} */}
              </div>
              <div className="vertical-separator"></div>
              <div className="detail-info-wrapper circuit-info-wrapper">
                  <div className="linked-circuit-container">
                    <h1>{this.toLocaleLanguage('linked_circuits_capital')}</h1>
                    <span>{this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination.TotalEntries} {this.toLocaleLanguage('total_circuits')}</span>
                  </div>
                  <div className="linked-circuit-search">
                   
                    <InputGroup size="sm" className="request-input-header">
                        <InputGroup.Text id="inputGroup-sizing-sm">
                              <Icons name="search" customClassName="icon-search" size="12px" />
                        </InputGroup.Text>
                        <FormControl  
                                maxLength={maxLength.limit_100}
                                value={this.state.searchVal}
                                onChange={(e) => this.setSearchValue(e)}
                                onBlur={this.searchAction}
                                onKeyPress={this.searchAction}
                                placeholder="Search Circuit..." 
                                aria-label="Small"
                                aria-describedby="inputGroup-sizing-sm"
                        />
                    </InputGroup>
                  </div>
                  <TablePagination  
                       key="table-pagination-key"
                       columns={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Headers}
                       pageList={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Data.Items}
                       pages={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination}
                       rowClickAction={(rowItem) => this.navigateToDetails(rowItem)}
                       paginationAction={(pageIndex) => getUserLinkedCircuit(endUserID, this.state.searchVal, pageIndex)}
                       totalPage={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination.TotalEntries}
                       isNotSortable={true}
                       haveLink={true}
                       modalPagination={true}
                       tableClassName="table-fit custom-table-header linked-circuit-modal-table-body"                            
                  />  
                    {/* {
                        <div className="table-container padding-top-5">
                            <TablePaginationExhibit2
                                key="table-pagination-key"
                                columns={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Headers}
                                pageList={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Data.Items}
                                pages={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination}
                                rowClickAction={(rowItem) => this.navigateToDetails(rowItem)}
                                paginationAction={(pageIndex) => getUserLinkedCircuit(endUserID, this.state.searchVal, pageIndex)}
                                totalPage={this.props.inventoryCircuit.inventoryUserLinkedCircuit.Pagination.TotalEntries}
                                isNotSortable={true}
                                haveLink={true}
                                tableClassName="table-fit"
                            />
                        </div>
                    }        */}
              </div>
           </div>
        </Modal.Body>        
      </Modal>

      </>
    );
  }
}

export default connect(
    state => {
        const { inventoryCircuit } = state;
        return {
            inventoryCircuit,
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, inventoryCircuitActions ),
            dispatch
        )
)(UserDetailsInfo);
